import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import clsx from 'clsx';

import CheckInCircleIcon from 'public/icons/larger-check-green.svg';
import styles from 'styles/components/Card.module.scss';

const Card = ({
  title,
  content,
  firstChild,
  buttonText,
  handleClick,
  selected,
  showButton,
  containerStyle,
  titleStyle,
}) => (
  <div
    className={clsx(
      styles.cardContainer,
      { [styles.opacity]: !selected && showButton },
      { [styles.hover]: showButton }
    )}
    style={firstChild ? { marginRight: 15, ...containerStyle } : { ...containerStyle }}
    onClick={() => showButton && handleClick()}
  >
    <div className={styles.header}>
      <h3 style={{ ...titleStyle }}>{title}</h3>
    </div>

    <div className={styles.content}>{content}</div>

    {selected && <CheckInCircleIcon />}

    {!showButton && (
      <Button color="primary" variant="contained" onClick={handleClick}>
        {buttonText}
      </Button>
    )}
  </div>
);

Card.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  firstChild: PropTypes.bool,
  showButton: PropTypes.bool,
  buttonText: PropTypes.string,
};

Card.defaultProps = {
  firstChild: false,
  showButton: false,
  buttonText: '',
};

export default Card;
